// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".results {\n  margin-top: 30px;\n}\n.selectable:hover {\n  background-color: #F2F2F2;\n  cursor: pointer;\n}\n.passname {\n  font-size: 14px;\n  line-height: 4px;\n}\n.count {\n  margin-right: 10px;\n}\n.quantityPicker {\n  margin: 20px 0 30px;\n}", ""]);
// Exports
module.exports = exports;
